const IMAGE_BASE = '/assets/image';

const IMAGE_SCHOOL = [
	{ image: `${IMAGE_BASE}/new_school/3school-min.webp` },
	{ image: `${IMAGE_BASE}/new_school/8school.webp` },
	{ image: `${IMAGE_BASE}/new_school/9school.webp` },
	{ image: `${IMAGE_BASE}/new_school/10school.webp` },
	{ image: `${IMAGE_BASE}/new_school/11school.webp` },
	{ image: `${IMAGE_BASE}/new_school/prathana_edited.webp` },
	{ image: `${IMAGE_BASE}/new_school/1school-min.webp` },
	{ image: `${IMAGE_BASE}/new_school/2school-min.webp` },
	{ image: `${IMAGE_BASE}/new_school/4school-min.webp` },
	{ image: `${IMAGE_BASE}/new_school/SCHOOL_FRONT_VIEWPNG-min.png` },
	{ image: `${IMAGE_BASE}/new_school/5school-min.webp` },
	{ image: `${IMAGE_BASE}/new_school/7school.webp` }
];

const FACILITY_Details = [
	{ image: `${IMAGE_BASE}/New_activity/badminton-min.webp`, facilityName: 'Badminton Court' },
	{ image: `${IMAGE_BASE}/New_activity/Basket_Ball-min.webp`, facilityName: 'Basket Ball Court' },
	{ image: `${IMAGE_BASE}/New_activity/shooting.webp`, facilityName: 'Shooting' },
	{ image: `${IMAGE_BASE}/New_activity/Volly_Ball-min.webp`, facilityName: 'Volly Ball Court' },
	{ image: `${IMAGE_BASE}/New_activity/Kabbadi-min.webp`, facilityName: 'Kabbadi Ground' },
	{ image: `${IMAGE_BASE}/New_activity/Foot_Ball-min.webp`, facilityName: 'Foot Ball Ground' },
	{ image: `${IMAGE_BASE}/New_activity/activity-min.webp`, facilityName: 'Art & Craft Room' },
	{ image: `${IMAGE_BASE}/New_activity/PHY-LAB-min.webp`, facilityName: 'Physics Lab' },
	{ image: `${IMAGE_BASE}/New_activity/BIO-LAB-min.webp`, facilityName: 'Biology Lab' },
	{ image: `${IMAGE_BASE}/New_activity/CHM-LAB-min.webp`, facilityName: 'Chemistry Lab' },
	{ image: `${IMAGE_BASE}/New_activity/Maths-Lab-min.webp`, facilityName: 'Maths Lab' },
	{ image: `${IMAGE_BASE}/New_activity/Maths-lab2-min.webp`, facilityName: 'Maths Lab' },
	{ image: `${IMAGE_BASE}/New_activity/Computer-Lab-min.webp`, facilityName: 'Computer Lab' },
	{ image: `${IMAGE_BASE}/New_activity/Montisory-Lab-min.webp`, facilityName: 'Montisory Lab' },
	{ image: `${IMAGE_BASE}/New_activity/Teacher_Trannig-min.webp`, facilityName: 'Teacher Training' }
];

const SPORTS_DETAILS = [
	{ image: `${IMAGE_BASE}/New_activity/Foot_Ball-min.webp`, facilityName: 'Foot Ball Ground' },
	{ image: `${IMAGE_BASE}/New_activity/badminton-min.webp`, facilityName: 'Badminton Court' },
	{ image: `${IMAGE_BASE}/New_activity/Basket_Ball-min.webp`, facilityName: 'Basket Ball Court' },
	{ image: `${IMAGE_BASE}/New_activity/shooting.webp`, facilityName: 'Shooting' },
	{ image: `${IMAGE_BASE}/New_activity/Volly_Ball-min.webp`, facilityName: 'Volly Ball Court' },
	{ image: `${IMAGE_BASE}/New_activity/Kabbadi-min.webp`, facilityName: 'Kabbadi Ground' }
];

const ART_CRAFT_DETAILS = [{ image: `${IMAGE_BASE}/New_activity/activity-min.webp`, facilityName: 'Art & Craft Room' }];

const ELECTION_GALLERY = [
	{ image: `${IMAGE_BASE}/photo_gallery/election_1.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_2.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_3.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_4.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_5.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_6.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_7.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_8.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_9.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/election_10.webp` }
];

const OATH_GALLERY = [
	{ image: `${IMAGE_BASE}/photo_gallery/oath_1.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/oath_2.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/oath_3.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/oath_4.webp` },
	{ image: `${IMAGE_BASE}/photo_gallery/oath_5.webp` }
];

const YOGA_GALLERY = [
	{ image: `${IMAGE_BASE}/Yoga/1Yoga.webp` },
	{ image: `${IMAGE_BASE}/Yoga/2Yoga.webp` },
	{ image: `${IMAGE_BASE}/Yoga/3Yoga.webp` },
	{ image: `${IMAGE_BASE}/Yoga/4Yoga.webp` },
	{ image: `${IMAGE_BASE}/Yoga/5Yoga.webp` },
	{ image: `${IMAGE_BASE}/Yoga/6Yoga.webp` }
];

const FUNCTION_GALLERY = [
	{ image: `${IMAGE_BASE}/Function/1Function.webp` },
	{ image: `${IMAGE_BASE}/Function/2Function.webp` },
	{ image: `${IMAGE_BASE}/Function/3Function.webp` },
	{ image: `${IMAGE_BASE}/Function/4Function.webp` },
	{ image: `${IMAGE_BASE}/Function/5Function.webp` },
	{ image: `${IMAGE_BASE}/Function/6Function.webp` },
	{ image: `${IMAGE_BASE}/Function/7Function.webp` },
	{ image: `${IMAGE_BASE}/Function/8Function.webp` },
	{ image: `${IMAGE_BASE}/Function/10Function.webp` },
	{ image: `${IMAGE_BASE}/Function/11Function.webp` },
	{ image: `${IMAGE_BASE}/Function/12Function.webp` },
	{ image: `${IMAGE_BASE}/Function/13Function.webp` },
	{ image: `${IMAGE_BASE}/Function/14Function.webp` },
	{ image: `${IMAGE_BASE}/Function/15Function.webp` },
	{ image: `${IMAGE_BASE}/Function/16Function.webp` },
	{ image: `${IMAGE_BASE}/Function/17Function.webp` },
	{ image: `${IMAGE_BASE}/Function/18Function.webp` },
	{ image: `${IMAGE_BASE}/Function/19Function.webp` },
	{ image: `${IMAGE_BASE}/Function/20Function.webp` },
	{ image: `${IMAGE_BASE}/Function/21Function.webp` },
	{ image: `${IMAGE_BASE}/Function/22Function.webp` },
	{ image: `${IMAGE_BASE}/Function/23Function.webp` }
];

const FACILITY_SLIDER_SETTINGS = {
	dots: true,
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 1,
	centerMode: true,
	centerPadding: '-40px',
	responsive: [
		{
			breakpoint: 880,
			settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 2 }
		},
		{
			breakpoint: 600,
			settings: { slidesToShow: 2, slidesToScroll: 1, initialSlide: 2 }
		},
		{
			breakpoint: 500,
			settings: { dots: false, slidesToShow: 2, slidesToScroll: 1, initialSlide: 1 }
		},
		{
			breakpoint: 320,
			settings: { dots: false, slidesToShow: 2, slidesToScroll: 1, initialSlide: 1 }
		}
	]
};

const DISABLE_DEV_TOOLS = () => {
	const disableContextMenu = (event: Event) => event.preventDefault();

	const disableRightClick = (event: KeyboardEvent) => {
		if ((event.ctrlKey && event.shiftKey && (event.key === 'I' || event.key === 'J')) || event.key === 'F12') {
			event.preventDefault();
		}
	};

	document.addEventListener('keydown', disableRightClick);
	document.addEventListener('contextmenu', disableContextMenu);

	return () => {
		document.removeEventListener('contextmenu', disableContextMenu);
		document.removeEventListener('keydown', disableRightClick);
	};
};

const MENU_ITEMS = [
	{ label: 'Home', subitems: [], link: '/' },
	{
		label: 'About Us',
		link: '',
		subitems: [
			{ label: 'About Prarthana School', link: '/aboutschool' },
			{ label: 'Mission & vision', link: '/mission&vision' },
			{ label: "Chairman's Message", link: '/chairman' },
			{ label: 'Rules & Regulation', link: '/rules&regulation' },
			{ label: 'School System', link: '/schoolsystem' },
			{ label: 'CBSE Mandatory Disclosure', link: '/cbsemandatorydiscolsure' }
		]
	},
	{
		label: 'Academics',
		link: '',
		subitems: [
			{ label: 'Training', link: '/training' },
			{ label: 'Transfer Certificate', link: '/transfer-certificate' },
			{ label: 'List Of Holidays', link: '/academics/16' },
			{ label: 'Academic Calendar', link: '/academics/10' },
			{ label: 'CCA & Competitions', link: '/academics/17' },
			{ label: 'National Education Policy', link: '/academics/18' },
			{ label: 'Exam Time Table', link: '/academics/19' },
			{ label: 'Fees', link: '/fees/9' }
		]
	},
	{
		label: 'Activity',
		link: '',
		subitems: [
			{ label: 'Co-Curricular Activities', link: '/cocurricularactivity' },
			{ label: 'Sports & Game', link: '/sports&game' },
			{ label: 'Art Room', link: '/art' },
			{ label: 'Music Room', link: '/music' },
			{ label: 'Dance Room', link: '/dance' },
			{ label: 'Housing & Dining', link: '/housing&dining' }
		]
	},
	{
		label: 'Gallery',
		link: '',
		subitems: [
			{ label: 'Photos', link: '/photo-gallery' },
			{ label: 'Videos', link: '/video-gallery' }
		]
	},
	{ label: 'Awards', subitems: [], link: '/awards' },
	{ label: 'Contact Us', subitems: [], link: '/contactUs' }
];

export {
	IMAGE_SCHOOL,
	FACILITY_Details,
	SPORTS_DETAILS,
	ART_CRAFT_DETAILS,
	ELECTION_GALLERY,
	OATH_GALLERY,
	FACILITY_SLIDER_SETTINGS,
	DISABLE_DEV_TOOLS,
	MENU_ITEMS,
	YOGA_GALLERY,
	FUNCTION_GALLERY
};
